import React from "react";
import PropTypes from "prop-types";

const formatTime = (value) => new Date(value).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" });
const formatSeconds = (ms) => `${(ms / 1000).toFixed(1)}s`;

const STEP_TITLE = {
    CART_CREATED: "Cart created",
    CART_UPDATED: "Cart items updated",
    PRICING: "Prices looked up and lines billed",
};

function describe(step) {
    const detail = step.detail || {};
    if (step.step === "PRICING") {
        return `${detail.lines} lines · ${detail.ready} READY · ${detail.notReady} not ready`
            + (detail.msAfterCartCreated != null ? ` · took ${formatSeconds(detail.msAfterCartCreated)} after the cart was created` : "");
    }
    const parts = [];
    if (detail.itemCount != null) parts.push(`${detail.itemCount} items`);
    if (detail.removedCount) parts.push(`${detail.removedCount} removed`);
    if (detail.prescriptionId != null) parts.push(`prescription #${detail.prescriptionId}`);
    return parts.join(" · ");
}

function CartJourney({ journey }) {
    if (!journey || journey.length === 0) return null;
    return (
        <div className="bg-white rounded-2xl shadow-soft-xl p-5">
            <h2 className="text-lg font-semibold font-sans text-gray-800 mb-3">Journey</h2>
            <ol className="relative border-l-2 border-gray-100 ml-2 flex flex-col gap-4">
                {journey.map((step, i) => (
                    <li key={`${step.step}-${i}`} className="ml-5">
                        <span className="absolute -left-[7px] mt-1 w-3 h-3 rounded-full bg-[#069079]" />
                        <p className="text-sm font-semibold font-sans text-gray-800">
                            {STEP_TITLE[step.step] || step.step}
                            <span className="ml-2 text-xs font-normal text-gray-400">{formatTime(step.at)}</span>
                        </p>
                        <p className="text-xs font-sans text-gray-500">{describe(step)}</p>
                    </li>
                ))}
            </ol>
        </div>
    );
}

CartJourney.propTypes = {
    journey: PropTypes.arrayOf(PropTypes.shape({
        at:     PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
        step:   PropTypes.string,
        detail: PropTypes.object,
    })),
};
CartJourney.defaultProps = { journey: [] };

export default CartJourney;
